import { render } from "./CompanySocials.vue?vue&type=template&id=37d9c2b6"
import script from "./CompanySocials.vue?vue&type=script&lang=js"
export * from "./CompanySocials.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__